import * as React from 'react';
import { useSelector } from 'react-redux';

import { Layout } from '../../components/Layout';
import { Promos as PromosComponent } from '../../components/Promos';
import { getDisplayName, getNewbuildingId, getPromos } from '../../selectors/newbuilding';
import { IPromo } from '../../types/newbuilding/promos';
import { PromoDescriptionModalContainer } from '../PromoDescriptionModal';
import { PromoItemContainer } from './PromoItem';
import { ToggleButton } from './ToggleButton';
import { trackClickPromoBlock, trackMorePromosClick } from './tracking';

export function Promos() {
  const [selectedPromo, setSelectedPromo] = React.useState<IPromo | null>(null);

  const promos: IPromo[] = useSelector(getPromos);
  const title = useSelector(getDisplayName);
  const newbuildingId = useSelector(getNewbuildingId);

  const onChangeOpen = React.useCallback((opened: boolean) => {
    if (opened) {
      trackMorePromosClick();
    }
  }, []);

  const openPromo = React.useCallback(
    (promo: IPromo) => {
      setSelectedPromo(promo);

      trackClickPromoBlock({
        promotionId: promo.promoId,
        promoType: promo.promoType,
        newbuildingId,
      });
    },
    [newbuildingId],
  );

  const closePromo = React.useCallback(() => {
    setSelectedPromo(null);
  }, []);

  if (!promos || !promos.length) {
    return null;
  }

  return (
    <Layout>
      <PromosComponent title={`Акции в ${title}`} Button={ToggleButton} onChangeOpen={onChangeOpen}>
        {promos.map((promo: IPromo) => (
          <PromoItemContainer key={promo.promoId} promo={promo} newbuildingId={newbuildingId} onClick={openPromo} />
        ))}
      </PromosComponent>
      {selectedPromo && <PromoDescriptionModalContainer open={true} onClose={closePromo} promo={selectedPromo} />}
    </Layout>
  );
}
